<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.ADD_OCCUPANT' | translate }}</h1>

  <mat-divider></mat-divider>

  @if (missingRequiredFields$ | async; as missingRequiredFields) {
    @if (missingRequiredFields.length > 0) {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
        <ul>
          @for (field of missingRequiredFields; track field.code) {
            <li>{{ field.label }}</li>
          }
        </ul>
      </mat-dialog-content>
      <mat-dialog-actions class="center">
        <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <div class="form-container">
          <form [formGroup]="leaseForm">
            <mat-slide-toggle id="new-occupant-toggle" formControlName="newOccupant">
              {{ 'LABEL.CREATE_NEW_OCCUPANT' | translate }}
            </mat-slide-toggle>

            @if (leaseForm.controls.newOccupant.value) {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'LABEL.OCCUPANT_NAME' | translate }}</mat-label>
                <input formControlName="occupantName" [id]="'create_occupant_name'" matInput required/>
                @if (leaseForm.controls.occupantName.hasError('required')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_REQUIRED' | translate }}
                  </mat-error>
                }
                @if (leaseForm.controls.occupantName.hasError('maxlength')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_MAX_LENGTH' | translate: {value: appConfig.FIELD_MAX_LENGTH} }}
                  </mat-error>
                }
              </mat-form-field>
            } @else {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'LABEL.OCCUPANT_NAME' | translate }}</mat-label>
                <mat-select-occupant-autocomplete formControlName="occupant" required>
                </mat-select-occupant-autocomplete>
              </mat-form-field>
            }

            @if (assetTypeAllowsSpaceModule) {
              <div class="space-form-field">

                <div class="ag-grid-container">
                  <ag-grid-angular (gridReady)="onGridReady($event)"
                                   [gridOptions]="gridOptions"
                                   domLayout="autoHeight"
                                   class="ag-theme-material"
                                   id="allocated-spaces-grid">
                  </ag-grid-angular>
                </div>
                @if (leaseForm.controls.spaces.touched && leaseForm.controls.spaces.hasError('required')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_REQUIRED' | translate }}
                  </mat-error>
                }
                @if (leaseForm.controls.spaces.hasError('incoherentSpaces')) {
                  <mat-error>
                    {{ 'ERROR.SPACES_INCOHERENT' | translate }}
                  </mat-error>
                }
              </div>
            }
          </form>

          <div class="button-container fx-layout-row fx-justify-end fx-align-center">
            <button mat-stroked-button matDialogClose="cancel" [id]="'cancel-button'">
              {{ 'BUTTON.CANCEL' | translate }}
            </button>
            <button [disabled]="!leaseForm.valid"
                    [id]="'add-button'"
                    color="accent"
                    mat-raised-button
                    matDialogClose="yes">
              {{ 'BUTTON.ADD' | translate }}
            </button>
          </div>
        </div>

      </mat-dialog-content>
    }
  } @else {
    <spinner></spinner>
  }
</div>
